import http from "../../http-common";

const create = (data) => {
  return http.post("/User/SignUp", data);
};

const update = (data) => {
  return http.put("/User/UpdateUser", data);
};

const get = (data) => {
  return http.post("/User/FilterUsers", data);
};

export default { create, update, get };
